<template>
  <div id="selfDraw">
    <div class="selfDraw">
      <breadcrumb :link-list="breadcrumbList"></breadcrumb>
      <div class="main">
        <div class="body">
          <div class="selectBox">
            <div class="title">
              <span/>
              请选择自抽号
            </div>
            <div class="productList" v-if="info.selfchoose_category && info.selfchoose_category.length">
              <div class="productItem" v-for="(item,index) in info.selfchoose_category" :key="index" @click="productClick(item)" :class="{'productItemSelect':item === product}">
                <span class="productItem_name">{{item.cat_name}}</span>
                <span class="productItem_price">¥{{item.price}}</span>
              </div>
            </div>
            <div class="productEmpty" v-else>
              <empty-state
                title="暂无自抽号商品"
                description="当前游戏暂未配置可购买的自抽号"
                icon-size="52"
              ></empty-state>
            </div>
          </div>
          <div class="infoBox">
            <div class="name">{{ product.cat_name }}</div>
            <div class="priceBox">
              <div class="price">
                <div class="label">商品价格：</div>
                <div class="totalPrice">¥{{ (amount * (product.price * 1).toString()).toFixed(2)}}</div>
              </div>
              <div class="sales">
                <span>
                  总销量
                </span>
                {{ info.self_choose_sold }}
              </div>
            </div>
            <div class="category">
              <div class="categoryItem" v-for="(item,index) in info.selfchoose_attribute" :key="index">
                <div class="categoryLabel">{{item.attr_name}}</div>
                <div class="categoryValue">{{item.attr_value}}</div>
              </div>
            </div>
            <div class="guarantee">
              <div class="label">保障</div>
              <div class="tag">封号补领</div>
              <div class="tip">(一个月内封号可补领账号)</div>
            </div>
            <div class="operating">
              <div class="amountBox">
                <div class="label">购买数量：</div>
                <el-input-number v-model="amount"  :min="1" :max="99" ></el-input-number>
              </div>
              <div class="share">
                分享好友
              </div>
            </div>
            <div class="btnGroup">
              <div class="buyBtn">立即购买</div>
              <div class="cusSerBtn">咨询客服</div>
            </div>
            <div class="tip">
              温馨提示：工作时间9：30-00：30，官网首页“客服验证”核验客服身份
            </div>
          </div>

        </div>
      </div>
      <div class="details_tabbar">
        <el-tabs v-model="activeName">
          <el-tab-pane label="交易须知" name="first">
            <img :src="info.self_trade_notice_img" alt="">
          </el-tab-pane>
          <el-tab-pane label="交易群" name="second">
            <div class="fourth_content" v-if="info.game_qun && info.game_qun.length">
              <div class="fourth_content_item" v-for="(item,index) in info.game_qun" :key="index">
                <div class="fourth_content_item_box">
                  <div>
                    <img src="@/assets/image/AllGame/contentItemTitle.png" alt="">
                  </div>
                  <div class="qq_logo">
                    <img src="@/assets/image/AllGame/QQlogo.png" alt="">
                  </div>
                  <div class="group_name">{{ item.name }}</div>
                  <a class="add_group" target="_blank" :href="item.link">点击加群</a>
                </div>
              </div>
            </div>
            <div class="groupEmpty" v-else>
              <empty-state
                title="暂无可加入交易群"
                description="您可以先咨询客服获取最新社群信息"
                icon="el-icon-chat-dot-round"
                icon-size="52"
              ></empty-state>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <left-product :product_id="123" :game_id="26"></left-product>
  </div>
</template>

<script>
import breadcrumb from "@/components/breadcrumb";
import leftProduct from "@/components/leftProduct";
import EmptyState from "@/components/emptyState";
import {
  apiSelfChooseInfo
} from "@/request/API";

export default {
  name: "index",
  props: {},
  components: {
    breadcrumb,
    leftProduct,
    EmptyState
  },
  data() {
    return {
      game_id:this.$route.query.game_id,
      // 面包屑
      breadcrumbList: [
        {name: '全部游戏',link:'/allGame'},
        {name: ''},
        {name: '自抽号'}
      ],
      info:{
        //自抽号列表
        selfchoose_category:[
          {cat_name:'',price:0}
        ],
        //分类属性
        selfchoose_attribute:[],
        //交流群
        game_qun:[],
      },
      //选中商品
      product:{},
      //购买数量
      amount:1,
      // 当前选中tabbar
      activeName: 'first',

    }
  },
  methods: {
    /**
     * 选择自抽号
     * @param item
     */
    productClick(item){
      this.product = item
      this.amount = 1
    },
    /**
     * 获取基本信息
     */
    getSelfChooseInfo(game_id){
      apiSelfChooseInfo({
        game_id
      }).then(res=>{
        this.info = res.data
        this.product = res.data.selfchoose_category[0]
        this.breadcrumbList[1].name = res.data.game_name
      })
    }
  },
  watch: {},
  created() {
    this.getSelfChooseInfo(this.game_id)
  },
  mounted() {
  }
}
</script>

<style scoped lang="less">
/deep/ .el-tabs__nav-wrap::after {
  content: none;
}

/deep/ .el-tabs__header {
  height: 64px;
  margin: 0;
  padding: 0 24px;
  border-bottom: 1px solid var(--border-soft, #E8E4DE);
  box-shadow: none !important;
}

/deep/ .el-tabs__nav-scroll,
/deep/ .el-tabs__nav {
  height: 64px;
  display: flex;
  align-items: center;
}

/deep/ .el-tabs__item {
  height: 36px;
  padding: 0 18px !important;
  margin-right: 8px;
  border-radius: 4px;
  font-size: 15px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 36px;
  transition: color 0.2s ease, background-color 0.2s ease;
}

/deep/ .el-tabs__item:hover {
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__item.is-active {
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: var(--brand-blue, #1A1D24);
  background: var(--brand-blue-light, #F0EDE8);
}

/deep/ .el-tabs__active-bar.is-top {
  height: 0;
}

#selfDraw {
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  background-color: var(--bg-page, #F7F5F2);

  .selfDraw {
    width: 1200px;
    max-width: 100%;
    box-sizing: border-box;

    .main {
      box-sizing: border-box;
      min-height: 526px;
      padding: 24px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
    }

    .body {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      gap: 24px;
    }

    .selectBox {
      width: 500px;
      flex: 0 0 500px;
      display: flex;
      flex-direction: column;

      .title {
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        height: 28px;
        margin: 0 0 14px;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: var(--text-main, #111827);
        line-height: 28px;

        span {
          display: inline-block;
          width: 4px;
          height: 18px;
          margin: 0 10px 0 0;
          background: var(--brand-blue, #1A1D24);
          border-radius: 4px;
        }
      }
    }

    .productList,
    .productEmpty {
      flex: 1 1 auto;
      min-height: 0;
      box-sizing: border-box;
    }

    .productList {
      margin: -8px -8px 0;
      padding: 8px 14px 8px 8px;
      overflow: auto;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--border-strong, #CBD5E1);
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background: var(--bg-section, #F7F5F2);
        border-radius: 4px;
      }
    }

    .productItem {
      box-sizing: border-box;
      width: 100%;
      min-height: 48px;
      padding: 0 16px;
      margin: 0 0 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 16px;
      background: var(--bg-section, #F7F5F2);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
      cursor: pointer;
      transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;

      .productItem_name {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .productItem_price {
        flex: 0 0 auto;
        color: var(--primary, #FF7A1A);
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
      }
    }

    .productItemSelect,
    .productItem:hover {
      color: var(--brand-blue, #1A1D24);
      background: var(--brand-blue-light, #F0EDE8);
      border-color: rgba(26, 29, 36, 0.35);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
    }

    .productEmpty,
    .groupEmpty {
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-section, #F7F5F2);
      border: 1px dashed var(--border-soft, #E8E4DE);
      border-radius: 4px;
    }

    .infoBox {
      box-sizing: border-box;
      width: 628px;
      min-height: 472px;
      padding: 24px;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: 0 10px 30px rgba(26, 29, 36, 0.08);

      .name {
        margin: 0 0 18px;
        font-size: 22px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        color: var(--text-main, #111827);
        line-height: 30px;
      }

      .priceBox {
        box-sizing: border-box;
        min-height: 76px;
        padding: 14px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        background: linear-gradient(135deg, var(--primary-soft, #FFF3E7) 0%, #FFFFFF 100%);
        border: 1px solid rgba(255, 122, 26, 0.18);
        border-radius: 4px;

        .price {
          display: flex;
          align-items: baseline;
          min-width: 0;

          .label {
            margin: 0 10px 0 0;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }

          .totalPrice {
            font-size: 30px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: var(--primary, #FF7A1A);
            line-height: 36px;
          }
        }

        .sales {
          flex: 0 0 auto;
          padding: 8px 12px;
          background: #FFFFFF;
          border: 1px solid rgba(26, 29, 36, 0.10);
          border-radius: 4px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--brand-blue, #1A1D24);

          span {
            margin-right: 6px;
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }
        }
      }

      .category {
        min-height: 82px;
        margin: 18px 0 8px;
        display: flex;
        flex-wrap: wrap;
        gap: 10px 12px;

        .categoryItem {
          box-sizing: border-box;
          width: calc((100% - 12px) / 2);
          min-height: 36px;
          padding: 7px 10px;
          display: flex;
          align-items: center;
          background: var(--bg-section, #F7F5F2);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;

          .categoryLabel,
          .categoryValue {
            font-size: 13px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            line-height: 20px;
          }

          .categoryLabel {
            flex: 0 0 68px;
            color: var(--text-muted, #9AA0AC);
          }

          .categoryValue {
            min-width: 0;
            color: var(--text-main, #111827);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .guarantee {
        min-height: 48px;
        padding: 12px 0;
        display: flex;
        align-items: center;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        .label {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
        }

        .tag {
          min-width: 86px;
          height: 28px;
          margin: 0 10px;
          padding: 0 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          box-sizing: border-box;
          background: var(--success-soft, #ECFDF5);
          border: 1px solid rgba(34, 197, 94, 0.18);
          border-radius: 4px;
          font-size: 13px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--success, #22C55E);
        }

        .tip {
          font-size: 12px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
        }
      }

      .operating {
        min-height: 58px;
        padding: 12px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);

        .amountBox {
          display: flex;
          align-items: center;

          .label {
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
          }

          /deep/.el-input-number {
            width: 128px;
            line-height: 34px;
          }

          /deep/.el-input__inner {
            height: 34px;
            padding: 0 34px;
            border: 1px solid var(--border-soft, #E8E4DE);
            color: var(--text-main, #111827);
          }

          /deep/.el-input-number__increase,
          /deep/.el-input-number__decrease {
            width: 32px;
            height: 32px;
            background: var(--bg-section, #F7F5F2);
            border-color: var(--border-soft, #E8E4DE);
            color: var(--text-secondary, #5A5F6B);
            transition: color 0.2s ease, background-color 0.2s ease;
          }

          /deep/.el-input-number__increase:hover,
          /deep/.el-input-number__decrease:hover {
            color: var(--brand-blue, #1A1D24);
            background: var(--brand-blue-light, #F0EDE8);
          }
        }

        .share {
          flex: 0 0 auto;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--brand-blue, #1A1D24);
          cursor: pointer;
          transition: color 0.2s ease;
        }

        .share:hover {
          color: #1A1D24;
        }
      }

      .btnGroup {
        margin: 18px 0 0;
        display: flex;
        align-items: center;
        gap: 12px;

        .buyBtn,
        .cusSerBtn {
          height: 52px;
          box-sizing: border-box;
          border-radius: 4px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          line-height: 52px;
          text-align: center;
          cursor: pointer;
          transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
        }

        .buyBtn {
          flex: 1 1 auto;
          color: #FFFFFF;
          background: var(--primary, #FF7A1A);
          box-shadow: 0 10px 20px rgba(255, 122, 26, 0.20);
        }

        .buyBtn:hover {
          background: var(--primary-hover, #F97316);
          box-shadow: 0 12px 24px rgba(255, 122, 26, 0.24);
        }

        .cusSerBtn {
          flex: 0 0 156px;
          color: var(--brand-blue, #1A1D24);
          background: var(--brand-blue-light, #F0EDE8);
          border: 1px solid rgba(26, 29, 36, 0.22);
        }

        .cusSerBtn:hover {
          background: #FFFFFF;
          border-color: rgba(26, 29, 36, 0.45);
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.10);
        }
      }

      > .tip {
        margin: 16px 0 0;
        padding: 8px 12px;
        background: var(--danger-soft, #FEF2F2);
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: var(--danger, #EF4444);
        line-height: 20px;
      }
    }

    .details_tabbar {
      margin: 16px 0 0;
      overflow: hidden;
      background-color: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

      /deep/ .el-tabs__content {
        padding: 24px;
      }

      img {
        display: block;
        max-width: 100%;
      }

      .fourth_content {
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
      }

      .fourth_content_item {
        width: calc((100% - 16px) / 2);
      }

      .fourth_content_item_box {
        min-height: 86px;
        box-sizing: border-box;
        padding: 16px;
        display: flex;
        align-items: center;
        gap: 12px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          border-color: rgba(26, 29, 36, 0.30);
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.08);
        }

        > div:first-of-type {
          flex: 0 0 auto;

          img {
            width: 28px;
            height: 28px;
            object-fit: contain;
          }
        }

        .qq_logo {
          flex: 0 0 auto;

          img {
            width: 32px;
            height: 32px;
            object-fit: contain;
          }
        }

        .group_name {
          min-width: 0;
          flex: 1 1 auto;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          color: var(--text-main, #111827);
          line-height: 22px;
        }

        .add_group {
          flex: 0 0 auto;
          width: 92px;
          height: 34px;
          background: var(--brand-gradient, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
          border-radius: 4px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 34px;
          text-align: center;
          transition: box-shadow 0.2s ease;
        }

        .add_group:hover {
          box-shadow: 0 8px 18px rgba(26, 29, 36, 0.20);
        }
      }

      .groupEmpty {
        min-height: 220px;
      }
    }
  }
}
</style>
